import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    sort:{
        type: 'default'
    },
    filter: 'All'
}

const filterSlice = createSlice({
    name: 'filter',
    initialState,
    reducers: {
        toggleSort: (state, action) => {
            state.sort.type = action.payload;
        },
        toggleFilter: (state, action) => {
            state.filter = action.payload;
        }
    }
})


export default filterSlice.reducer;
export const { toggleSort, toggleFilter } = filterSlice.actions;